import { useState, useCallback } from 'react';
import useDeepCompareEffect from './helpers/useDeepCompareEffect';
import createObserverPublisher from './helpers/createObserverPublisher';
var publishers;
export default function useObserver(Observer, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      observerOptions = _ref.observerOptions,
      subscribeOptions = _ref.subscribeOptions;

  var _useState = useState({}),
      entry = _useState[0],
      setEntry = _useState[1];

  var _useState2 = useState(),
      element = _useState2[0],
      setElement = _useState2[1];

  var ref = useCallback(function (node) {
    if (node !== null) {
      setElement(node);
    }
  }, []);
  useDeepCompareEffect(function () {
    if (!element || !Observer) {
      return undefined;
    }

    if (!publishers) {
      publishers = new Map();
    }

    var options = publishers.get(Observer);

    if (!options) {
      options = new Map();
      publishers.set(Observer, options);
    }

    var optionId = observerOptions ? JSON.stringify(observerOptions) : 'default';
    var publisher = options.get(optionId);

    if (!publisher) {
      publisher = createObserverPublisher(Observer, observerOptions);
      options.set(optionId, publisher);
    }

    var _publisher = publisher,
        subscribe = _publisher.subscribe,
        unsubscribe = _publisher.unsubscribe;
    subscribe({
      element: element,
      options: subscribeOptions
    }, function (newEntry) {
      return setEntry(newEntry);
    });
    return function () {
      return unsubscribe(element);
    };
  }, [element, Observer, observerOptions, subscribeOptions]);
  return [ref, entry];
}